<template>
  <form-wizard
    ref="wizard"
    @on-complete="storeUpdate"
    title
    subtitle
    :back-button-text="$t('common_words.back')"
    :next-button-text="$t('common_words.next')"
    :finish-button-text="$t('common_words.save')"
    class="custom-padding-wz-header"
  >
    <tab-content
      v-for="(tab, key) in tabsContent"
      :key="key"
      :title="tab.title"
      v-if="tab.show || true"
      :before-change="() => validateStep(tab.reference)"
    >
      <component
        :is="tab.component"
        :ref="tab.reference"
        @emit-methods="handleEmitter"
        @on-validated="onStepValidated"
        @showHideLoading="showHideLoading"
      />
    </tab-content>
    <tab-content :title="$t('common_words.confirm')">
      <p class="cm-mg-p-wzd text-center text-muted">
        {{ tabsContent.length + 1 }}.
        {{ $t('common_words.verify_inputed_information') }}
      </p>
      <br />
      <slot name="dataConfirm"></slot>
    </tab-content>
  </form-wizard>
</template>
<script>
import MixinLoading from 'src/mixins/mixin-loading';

export default {
  name: 'form-wizard-layout',
  mixins: [MixinLoading],
  props: {
    title: {
      type: String,
      default: '',
    },
    tabsContent: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    storeUpdate() {
      this.$emit('on-complete');
    },
    validateStep(ref) {
      return this.$refs[ref][0].validate();
    },
    onStepValidated(model) {
      this.$emit('on-validated', model);
    },
    handleEmitter(indexToEmit, data) {
      this.$emit(indexToEmit, data);
    },
  },
};
</script>
